"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { buildLoginUrl, useAuth } from "@/lib/auth";

export default function Home() {
  const router = useRouter();
  const { user, onboardingCompleted, isMePending } = useAuth();

  useEffect(() => {
    if (isMePending) return;

    if (!user) {
      router.replace(buildLoginUrl());
      return;
    }

    if (onboardingCompleted === false) {
      router.replace("/onboarding");
      return;
    }

    if (onboardingCompleted === true) {
      router.replace("/dashboard");
      return;
    }

    // Defensive: `me` returned a user but no boolean (unexpected) — prefer onboarding over flashing dashboard.
    if (user) {
      router.replace("/onboarding");
    }
  }, [isMePending, user, onboardingCompleted, router]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-sm text-muted-foreground">Preparing your workspace…</p>
    </div>
  );
}
